import { Crud, HttpClient, httpClient } from 'lib/HttpClient';

class PerkTemplateApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'perktemplates');
    }
}

export const perkTemplateApi = new PerkTemplateApi(httpClient);
